import React from "react"
import { ReactSVG } from "react-svg"
import * as styles from "./transport-title.module.scss"
import { TransportTitleListFieldsFragment } from "../../../../graphql-types"
import sanitizeHtml from "sanitize-html"
import { configureDecorativeSVGAccessibility } from "../../../utils/accessibility"
import RectangularButton from "../rectangular-button/rectangular-button"

type RenderProps = {
  transportTitleData: TransportTitleListFieldsFragment
  detailsLabel: string
}

const TransportTitle: React.FC<RenderProps> = ({ transportTitleData }) => {
  const sanitizedDescription: string = transportTitleData.description
    ? sanitizeHtml(transportTitleData.description, {
        allowedTags: ["b", "i", "em", "strong", "a", "p"],
      })
    : ""

  return (
    <div className={styles.transportTitle}>
      <div className={styles.transportTitleLabel}>{transportTitleData.title}</div>
      <div className={styles.transportTitleContent}>
        {transportTitleData.picture && transportTitleData.picture.url ? (
          <div className={styles.transportTitleImageBox}>
            {transportTitleData.picture.format === "svg" ? (
              <ReactSVG src={transportTitleData.picture.url} beforeInjection={configureDecorativeSVGAccessibility} />
            ) : (
              <img src={transportTitleData.picture.url} alt="" />
            )}
          </div>
        ) : null}
        <div className={styles.transportTitleDescription}>
          <div className={styles.truncateContent}>
            <p dangerouslySetInnerHTML={{ __html: sanitizedDescription }} />
          </div>
          <div className={styles.transportTitleActionButton}>
            {transportTitleData.redirectionUrl ? (
              <RectangularButton
                label={transportTitleData.redirectionLabel}
                redirectUrl={transportTitleData.redirectionUrl}
              ></RectangularButton>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransportTitle
